import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

let fadeObserver
let revealObserver
let sweepObserver

export const onClientEntry = () => {
  if (typeof document === "undefined") return
  document.documentElement.classList.add("js")
}

export const onRouteUpdate = () => {
  if (typeof document === "undefined") return

  // 前回の監視を確実に破棄
  if (fadeObserver) fadeObserver.disconnect()
  if (revealObserver) revealObserver.disconnect()
  if (sweepObserver) sweepObserver.disconnect()

  // =========================
  // 1) fadeInUp
  // =========================
  const fadeTargets = document.querySelectorAll(".fadeInUp")
  fadeObserver = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add("on")
        obs.unobserve(entry.target)
      })
    },
    { threshold: 0.1 }
  )
  fadeTargets.forEach((el) => {
    if (!el.classList.contains("on")) fadeObserver.observe(el)
  })

  // =========================
  // 2) js-reveal
  // =========================
  const revealTargets = document.querySelectorAll(".js-reveal")
  revealObserver = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.remove("is-in")
        void entry.target.offsetHeight
        requestAnimationFrame(() => entry.target.classList.add("is-in"))
        obs.unobserve(entry.target)
      })
    },
    { threshold: 0.25 }
  )
  revealTargets.forEach((el) => {
    if (!el.classList.contains("is-in")) revealObserver.observe(el)
  })

  // =========================
  // 3) comVisual（KV即発火）
  // =========================
  const comVisuals = document.querySelectorAll(".comVisual")
  comVisuals.forEach((el) => {
    el.classList.remove("is-in")
    void el.offsetHeight
    requestAnimationFrame(() => el.classList.add("is-in"))
  })

  // =========================
  // 4) revealSweep（職種ページ用：スクロール発火）
  // =========================
  const sweepTargets = document.querySelectorAll(".revealSweep")
  sweepObserver = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.remove("is-in")
        void entry.target.offsetHeight
        requestAnimationFrame(() => entry.target.classList.add("is-in"))
        obs.unobserve(entry.target)
      })
    },
    { threshold: 0.25 }
  )
  sweepTargets.forEach((el) => {
    if (!el.classList.contains("is-in")) sweepObserver.observe(el)
  })
}
